module.exports = __webpack_public_path__ + "assets/img/c2c.dfc6874d.png";